<template>
    <div class="pay_content">
        <div class="pay_head_content" v-if="this.$route.params.type == 0">
            <div class="pay_head_tobepaid"><span>待付金额：</span><small>{{waitpaycost | moneyFilter}}元</small></div>
            <div class="pay_head_remainingtime" v-if="openclosecheck == 1 && closetimeformat != ''"><span>支付剩余时间</span><small>{{closetimeformat}}</small></div>
            <div class="pay_head_seeorder" v-if="this.$route.params.type == 0"><router-link :to="{name: '订货详情', params: {id: this.$route.params.id}}">查看订单<i class="icon iconfont icon-icon_zhankai_xiangxia1"></i></router-link></div>
        </div>
        <div class="h20" v-if="acountpay.is_open == 1"></div>
        <Form ref="payformdata" :model="payformdata" :rules="payform" :label-width="112">
            <div class="pay_box" v-if="acountpay.is_open == 1">
                <div class="pay_title_content"><span>预存款帐户</span></div>
                <div class="pay_form_content">
                    <FormItem label="当前余额：" style="margin-bottom: 0;">
                        <span class="pay_balance">{{yucost}}元</span>
                    </FormItem>
                    <FormItem label="余额支付：">
                        <InputNumber v-model="depositmoney" :min="0.00" @on-change="depositmoneyChange" @on-blur="depositmoneyBlur" :disabled="yucost <= 0 || payformdata.money == waitpaycost" style="width: 165px;"></InputNumber>
                        <small class="pay_form_sign">元</small>
                        <p class="pay_form_tips">预存款支付可与其它支付方式组合支付</p>
                    </FormItem>
                </div>
            </div>
            <div class="h20"></div>
            <div class="pay_box">
                <div class="pay_title_content"><span>其他支付方式</span></div>
                <div class="pay_modepayment_content">
                    <ul>
                        <li :class="{active: item.checked}" v-for="(item, index) in modepayment" :key="index" @click="selectpay(item)" v-if="item.is_open == 1">
                            <i class="icon iconfont tb" :class="[item.icon]" :style="{color: item.color}"></i>
                            <span>{{item.name}}</span>
                            <i class="icon iconfont icon-xuanzezhuangtai"></i>
                        </li>
                    </ul>
                </div>
                <div class="pay_form_content" v-if="paychecked == 'appalipay' || paychecked == 'wxapppay'">
                    <FormItem label="付款金额：" prop="money">
                        <InputNumber v-model="payformdata.money" :min="0.00" :disabled="this.$route.params.type == 0 && depositmoney == waitpaycost" @on-change="otherpayChange" @on-blur="otherpayBlur" style="width: 165px;"></InputNumber>
                        <small class="pay_form_sign">元</small>
                        <Button type="warning" class="pay_online_btn" @click="onlinepayBtn" :disabled="(this.$route.params.type == 0 && depositmoney == waitpaycost) || payformdata.money == 0 || payrevise">确定金额</Button>
                        <p class="pay_form_tips">填写或者修改付款金额，请先点击确定再扫码支付</p>
                    </FormItem>
                    <div class="qrcode_content" v-if="qrcodeshow">
                        <div class="qrcode_price">
                            <span>扫码支付</span>
                            <b>￥{{payformdata.money}}</b>
                        </div>
                        <div class="qrcode_tiem" v-if="!qrcodebeoverdue">支付剩余时间:{{paycountdown}}</div>
                        <div class="qrcode_refresh" v-if="qrcodebeoverdue" @click="onlinepayBtn">刷新二维码</div>
                        <div class="qrcode_main">
                            <img :src="qrcode" />
                            <span v-if="qrcodebeoverdue">二维码已过期请重新获取</span>
                        </div>
                        <div class="qrcode_tips">
                            <i class="icon iconfont icon-zhifubao" v-if="paychecked == 'appalipay'"></i>
                            <i class="icon iconfont icon-weixinzhifu" v-if="paychecked == 'wxapppay'"></i>
                            <i class="icon iconfont icon-saoyisao"></i>
                            <div>
                                <span v-if="paychecked == 'appalipay'">打开手机支付宝</span>
                                <span v-if="paychecked == 'wxapppay'">打开手机微信</span>
                                <span>扫一扫继续付款</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pay_form_content" v-if="paychecked == 'downlinepay'">
                    <FormItem label="付款金额：" prop="money">
                        <InputNumber v-model="payformdata.money" :min="0.00" :disabled="this.$route.params.type == 0 && depositmoney == waitpaycost" @on-change="otherpayChange" @on-blur="otherpayBlur" style="width: 165px;"></InputNumber>
                        <small class="pay_form_sign">元</small>
                    </FormItem>
                    <FormItem label="收款帐户：" v-if="banklist.is_open == 1">
                        <div class="pay_paymentaccount_content">
                            <ul>
                                <li :class="{active: item.checked}" v-for="(item, index) in banklist.acountlist" :key="index" @click="selectbank(item)">
                                    <div class="pay_paymentaccount_list"><small>{{item.bank}}</small><small>{{item.name}}</small></div>
                                    <div class="pay_paymentaccount_list"><span>{{item.num}}</span></div>
                                    <i class="icon iconfont icon-xuanzezhuangtai"></i>
                                </li>
                            </ul>
                        </div>
                    </FormItem>
                    <FormItem label="付款日期：">
                        <DatePicker type="datetime"  format="yyyy-MM-dd HH:mm" :value="payformdata.datetime" :editable="false" :clearable="false" placeholder="付款日期" @on-change="dateChange"></DatePicker>
                    </FormItem>
                    <FormItem label="备注：">
                        <Input v-model="remarks" type="textarea" :rows="4" placeholder="输入商品备注信息" style="width: 400px;" />
                    </FormItem>
                    <FormItem label="上传凭证：" v-if="banklist.is_bankticket == 1">
                        <div class="uploadfile_content">
                            <small>（请上传图片，最多5张，单张大小不超过4M，支持格式：jpg,png,jpeg）</small>
                            <Upload
                                ref="upload"
                                :action="uploadaction"
                                :show-upload-list="false"
                                :default-file-list="payformdata.defaultList"
                                :multiple="true"
                                :format="['jpg','jpeg','png']"
                                accept=".jpg, .jpeg, .png"
                                name="imgFile"
                                :max-size="payformdata.filemaxsize"
                                :before-upload="uploadBefore"
                                :on-progress="uploadProgress"
                                :on-success="uploadSuccess"
                                :on-error="uploadError"
                                :on-remove="uploadRemove"
                                :on-exceeded-size="uploadExceededSize"
                            >
                                <Button class="uploadfile_btn">选择文件</Button>
                            </Upload>
                            <div class="uploadfile_list">
                                <ul>
                                    <li v-for="(item, index) in payformdata.uploadList" :key="index">
                                        <template v-if="item.status === 'finished'">
                                            <span>{{item.name}}</span>
                                            <a :href="item.url" target="_blank">查看</a>
                                            <a href="javascript:;" @click="deluploadfile(item)">删除</a>
                                        </template>
                                        <template v-else>
                                            <div style="width: 260px;">
                                                <Progress v-if="item.showProgress" :percent="item.percentage"></Progress>
                                            </div>
                                        </template>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </FormItem>
                </div>
            </div>
            <div
                class="pay_submit_content"
                v-if="paychecked != 'appalipay' && paychecked != 'wxapppay'"
                :style="{
                    marginLeft: (paychecked != 'appalipay' && paychecked != 'wxapppay') ? '30px' : '112px',
                    marginTop: (paychecked != 'appalipay' && paychecked != 'wxapppay') ? '10px' : '0',
                }"
            >
                <Button type="warning" @click="confirmpay" :disabled="openclosecheck == 1 && overdue">确认支付</Button>
            </div>
        </Form>
        <Modal v-model="paysuccess" width="318" :closable="false" :mask-closable="false" class-name="vertical-center-modal">
            <p slot="header"></p>
            <p slot="footer"></p>
            <div class="paysuccess_body">
                <img src="static/images/paysuccess.png" />
                <h3>支付成功</h3>
                <span>已成功支付￥{{(payformdata.money + depositmoney).toFixed(2)}}</span>
                <p v-if="this.$route.params.type == 0">2秒后到达<router-link :to="{name: '订货详情', params: {id: this.$route.params.id}}">订货详情</router-link></p>
                <p v-if="this.$route.params.type == 1">2秒后到达<router-link to="/PayRecordCapital">支付记录</router-link></p>
            </div>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
import {toMoney} from '@/filter/moneyFilter.js'
let clearInter, clearcheckpay

let dates = new Date();

export default {
    data() {
        return {
            paysuccess: false, // 支付成功弹窗提示
            waitpaycost: 0, // 此订单未支付金额
            allcost: 0, // 此订单需要支付的总金额
            paycost: 0, // 此订单已支付的金额
            yucost: 0, // 当前账号余额
            paywaitsurecost: 0, // 此订单已提交了，付款记录未确认的总金额
            openclosecheck: 0, // 是否开启时间检测 1开启 其他不开启
            closetime: 0, // 剩余支付时间
            closetimeformat: 0, // 支付剩余时间
            depositmoney: 0, // 余额支付
            overdue: false, // 是否超时 true 超时 false 不超时
            acountpay: { // 账户余额
                is_open: 0, // 是否开启 1开启 0未开启
                code: '', // 识别CODE，提交支付时需要提交
            },
            payid: 0, // 在线支付id
            paychecked: '', // 当前选中支付方式
            modepayment: [], // 支付方式 0 支付宝 1 微信 2 线下支付
            banklist: [], // 收款帐号列表
            bankid: 0, // 选中银行账号id
            qrcodeshow: false, // 在线支付二维码是否显示
            qrcode: '', // 在线支付二维码
            paycountdown: '15分0秒', // 在线支付倒计时
            qrcodebeoverdue: false, // 二维码是否已过期
            payrevise: true, // 其它支付方式付款金额是否修改
            remarks: '', // 线下支付备注
            payformdata: { // 其他支付方式表单
                money: 0,
                datetime: dates.getFullYear() + '-' + (dates.getMonth() + 1) + '-' + dates.getDate() + ' ' + dates.getHours() + ':' + dates.getMinutes(), // 默认付款日期（显示当天）
                filemaxsize: Math.pow(4, 6), // 文件大小限制
                defaultList: [], // 默认上传文件列表
                uploadList: [], // 显示已上传列表
            },
            payform: { // 其他支付方式表单验证
                // money: [{ required: true, message: ' ', trigger: 'blur' }],
            },
            submit: {
                payfor: 'acountpay', // order 支付订单 acount // 
            },
            uploadaction: '', // 上传凭证地址
        }
    },
    methods: {
        getInfo () { // 获取支付信息
            this.http.post((this.$route.params.type == 0 ? api.getpay : api.recharge), (this.$route.params.type == 0 ? {client: 'pc', orderid: this.$route.params.id} : {client: 'pc'}))
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data.msg)
                    // 订单信息
                    this.waitpaycost = response.data.msg.paydata.waitpaycost
                    this.allcost = response.data.msg.paydata.allcost
                    this.paycost = response.data.msg.paydata.paycost
                    this.yucost = response.data.msg.paydata.yucost
                    this.paywaitsurecost = response.data.msg.paydata.paywaitsurecost
                    this.openclosecheck = response.data.msg.paydata.openclosecheck
                    this.closetime = response.data.msg.paydata.closetime
                    if (response.data.msg.paydata.openclosecheck == 1 || response.data.msg.paydata.closetimeformat != '') {
                        this.TimeDown(response.data.msg.paydata.closetimeformat)
                    }
                    this.acountpay = response.data.msg.paydata.acountpay
                    this.paychecked = response.data.msg.paydata.acountpay.code
                    response.data.msg.paydata.alipay.icon = 'icon-zhifubao'
                    response.data.msg.paydata.alipay.color = '#06b4fd'
                    response.data.msg.paydata.alipay.checked = false
                    response.data.msg.paydata.weixinpay.icon = 'icon-weixinzhifu'
                    response.data.msg.paydata.weixinpay.color = '#6bcc03'
                    response.data.msg.paydata.weixinpay.checked = false
                    response.data.msg.paydata.downlinepay.icon = 'icon-zijinfuzhi'
                    response.data.msg.paydata.downlinepay.color = '#5b5fc2'
                    response.data.msg.paydata.downlinepay.checked = false
                    if (response.data.msg.paydata.downlinepay.is_open == 1) {
                        for (var i = 0; i < response.data.msg.paydata.downlinepay.acountlist.length; i++) {
                            response.data.msg.paydata.downlinepay.acountlist[i].checked = false
                        }
                        response.data.msg.paydata.downlinepay.acountlist[0].checked = true
                        this.bankid = response.data.msg.paydata.downlinepay.acountlist[0].id
                        this.banklist = response.data.msg.paydata.downlinepay
                    }
                    this.modepayment.push(response.data.msg.paydata.alipay)
                    this.modepayment.push(response.data.msg.paydata.weixinpay)
                    this.modepayment.push(response.data.msg.paydata.downlinepay)
                }
            })
            .catch(error => {
                this.$Message.error(error)
                // this.$router.push('/Order')
            })
        },
        submitorder () { // 提交支付
            let payimgarr = []
            let payimg = ''
            if (this.banklist.is_bankticket == 1 && this.paychecked == 'downlinepay') {
                for (var i = 0; i < this.$refs.upload.fileList.length; i++) {
                    payimgarr.push(this.$refs.upload.fileList[i].url)
                }
                payimg = payimgarr.join(',')
            }

            this.http.post(api.sbumitpay,
                {
                    payfor: (this.$route.params.type == 0 ? 'order' : 'acount'),
                    paycode: this.paychecked,
                    orderid: this.$route.params.type == 0 ? this.$route.params.id : '',
                    cost: this.payformdata.money == 0 ? this.depositmoney : this.payformdata.money,
                    acountcost: this.payformdata.money != 0 ? this.depositmoney : 0,
                    downlinepaytime: this.payformdata.datetime,
                    downlineacountid: this.bankid,
                    downlinestro: this.remarks,
                    downlinepayimg: payimg,
                }
            )
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data)
                    if (response.data.msg.payid != undefined) {
                        this.qrcode = this.getWebsite() + api.qrcodepay + this.getCookie('cook_ShopId') + '&paycode=' + response.data.msg.paycode + '&payid=' + response.data.msg.payid
                        this.payid = response.data.msg.payid
                        this.qrcodeshow = true
                        this.qrcodebeoverdue = false
                        clearInterval(clearInter)
                        this.paytimedown()
                        clearcheckpay = setInterval(() => {
                            this.paycheck()
                        }, 3000)
                    }  else {
                        this.paysuccessjump()
                    }
                }
            })
            .catch(error => {
                this.$Message.error(error);
            })
        },
        paycheck () { // 检测在线支付是否成功
            this.http.post(api.payonlinestat,
                {
                    paycode: this.paychecked,
                    payid: this.payid,
                }
            )
            .then(response => {
                if (response.data.msg.paylog.status == 1) {
                    clearInterval(clearcheckpay)
                    this.paysuccessjump()
                } else if (response.data.msg.paylog.status == 2) {
                    this.$Message.error('支付异常')
                    this.qrcodebeoverdue = true
                }
            })
            .catch(error => {
                this.$Message.error(error)
            })
        },
        paysuccessjump () { // 支付成功后跳转链接
            this.paysuccess = true
            setTimeout(() => {
                if (this.$route.params.type == 0) {
                    this.$router.push({
                        name: '订货详情',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                }
                if (this.$route.params.type == 1) {
                    this.$router.push('/PayRecordCapital')
                }
                this.paysuccess = false
            }, 2000)
        },
        selectpay (item) { // 选择支付方式
            clearInterval(clearInter)
            if (this.paychecked == item.code) {            
                item.checked = !item.checked
                this.paychecked = this.acountpay.code
                this.payformdata.money = 0
            } else {
                for (var i = 0; i < this.modepayment.length; i++) {
                    this.modepayment[i].checked = false
                }
                item.checked = true
                this.paychecked = item.code
            }
            this.qrcodeshow = false
        },
        selectbank (item) { // 选择收款帐号
            for (var i = 0; i < this.banklist.acountlist.length; i++) {
                this.banklist.acountlist[i].checked = false
            }
            item.checked = true
            this.bankid = item.id
        },
        depositmoneyChange (e) { // 余额支付
            if (e == '') e = 0
            let paycost = parseFloat((this.depositmoney + this.payformdata.money).toFixed(2))

            if (this.yucost >= this.waitpaycost) {
                if (paycost > this.waitpaycost) {
                    setTimeout(() => {
                        this.depositmoney =  parseFloat((this.waitpaycost - this.payformdata.money).toFixed(2))
                    }, 0)
                    this.$Message.warning('已达到最大支付金额')
                }
            } else {
                if (paycost > this.yucost) {
                    setTimeout(() => {
                        this.depositmoney =  parseFloat((this.yucost - this.payformdata.money).toFixed(2))
                    }, 0)
                    this.$Message.warning('已达到余额')
                }
            }
        },
        depositmoneyBlur () { // 输入框失去焦点
            this.depositmoney =  parseFloat((this.depositmoney).toFixed(2))
        },
        otherpayChange (e) { // 其它支付
            if (this.$route.params.type == 0) {
                if (e == '') e = 0
                if (e != 0 && e !== '') {
                    this.payrevise = false
                } else {
                    this.payrevise = true
                }
                let paycost = parseFloat((this.depositmoney + this.payformdata.money).toFixed(2))
                if (paycost > this.waitpaycost) {
                    setTimeout(() => {
                        this.payformdata.money =  parseFloat((this.waitpaycost - this.depositmoney).toFixed(2))
                    }, 0)
                    this.$Message.warning('已达到最大支付金额')
                }
            } else {
                this.payformdata.money =  parseFloat((e).toFixed(2))
            }
        },
        otherpayBlur () { // 输入框失去焦点
            this.payformdata.money =  parseFloat((this.payformdata.money).toFixed(2))
        },
        dateChange (e) { // 线下支付修改日期
            this.payformdata.datetime = e
        },
        confirmpay () { // 确认支付
            this.submitorder()
        },
        onlinepayBtn () { // 在线支付生成二维码
            this.payrevise = true
            this.submitorder()
        },
        uploadBefore () { // 上传文件之前
            const check = this.payformdata.uploadList.length < 5;
            if (!check) {
                this.$Message.warning({
                    content: '最多上传5张'
                });
            }
            return check;
        },
        uploadProgress (event, file, fileList) { // 文件上传时
            console.log('上传时')
            console.log(event)
            console.log(file)
            console.log(fileList)
        },
        uploadSuccess (response, file, fileList) { // 文件上传成功
            console.log('上传成功')
            console.log(response)
            console.log(file)
            console.log(fileList)
            file.url = file.response[0].url
            file.name = file.response[0].name;
            this.$Message.success({
                content: file.name + '上传成功'
            })
        },
        uploadError (error, file, fileList) { // 文件上传失败
            console.log('上传失败')
            console.log(error)
            console.log(file)
            console.log(fileList)
            this.$Message.error({
                content: fileList.name + '上传失败'
            })
        },
        uploadRemove (file, fileList) { // 文件列表移除文件时
            console.log('移除')
            console.log(file)
            console.log(fileList)
        },
        uploadExceededSize (file, fileList) { // 文件超出大小
            console.log('超出大小')
            console.log(file)
            console.log(fileList)
        },
        deluploadfile (file) { // 删除上传文件
            const fileList = this.$refs.upload.fileList;
            this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        },
        TimeDown (endDateStr) { // 倒计时
            //结束时间
            var endDate = new Date(endDateStr);
            //当前时间
            var nowDate = new Date();
            //相差的总秒数
            var totalSeconds = parseInt((endDate - nowDate) / 1000);
            //天数
            var days = Math.floor(totalSeconds / (60 * 60 * 24));
            //取模（余数）
            var modulo = totalSeconds % (60 * 60 * 24);
            //小时数
            var hours = Math.floor(modulo / (60 * 60));
            modulo = modulo % (60 * 60);
            //分钟
            var minutes = Math.floor(modulo / 60);
            //秒
            var seconds = modulo % 60;
            //输出到页面
            if (days > 0) {
                this.closetimeformat = days + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒"
            } else if (hours > 0) {
                this.closetimeformat = hours + "小时" + minutes + "分钟" + seconds + "秒"
            } else if (minutes > 0) {
                this.closetimeformat = minutes + "分钟" + seconds + "秒"
            } else if (seconds > 0) {
                this.closetimeformat = seconds + "秒"
            } else {
                this.closetimeformat = '订单已过期'
                this.overdue = true
            }
            //延迟一秒执行自己
            setTimeout(() => {
                this.TimeDown(endDateStr)
            }, 1000)
        },
        paytimedown () { // 在线支付倒计时
            var m = 14;  //分
            var s = 59;  //秒
            clearInter = setInterval(() => {
                this.paycountdown = m + '分' + s + '秒'
                if(m == 0 && s == 0){
                    m = 14
                    s = 59
                    this.qrcodebeoverdue = true
                    clearInterval(clearInter)
                } else if (m >= 0) {
                    if (s > 0) {
                        s--
                    } else if (s == 0){
                        m--
                        s = 59
                    }
                }
            }, 1000)
        }
    },
    filters: {
        moneyFilter (money) {
            return toMoney(money)
        }
    },
    created () {
        this.getInfo()
        this.uploadaction = this.getWebsite() + api.payuploadfile + this.getCookie('cook_ShopId') + '&cus_uid=' + this.getCookie('cook_cus_uid') + '&cus_pwd=' + this.getCookie('cook_cus_pwd')
    },
    watch: {
        paychecked (newval, oldval) {
            if (newval == 'downlinepay') {
                setTimeout(() => {
                    if (this.$refs.upload != undefined) this.payformdata.uploadList = this.$refs.upload.fileList
                }, 0)
            }
        }
    }
}

</script>

<style scoped>

.pay_head_content {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 30px;
}

.pay_head_tobepaid,
.pay_head_remainingtime {
    margin-right: 30px;
}

.pay_head_tobepaid > span {
    font-size: 14px;
    color: #333;
}

.pay_head_tobepaid > small {
    font-size: 20px;
    color: #FF3333;
}

.pay_head_remainingtime > span {
    font-size: 14px;
    color: #666;
}

.pay_head_remainingtime > small {
    font-size: 15px;
    color: #FF8000;
}

.pay_head_seeorder > a {
    height: 30px;
    line-height: 31px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px 0 14px;
    font-size: 16px;
    color: #0C1F6D;
    border: 1px solid #0C1F6D;
    border-radius: 100px;
}

.pay_head_seeorder > a > i {
    margin-left: 4px;
    font-size: 16px;
}

.pay_box .ivu-form-item {
    margin-bottom: 17px;
}

.pay_title_content {
    padding: 20px 30px 0;
}

.pay_title_content > span {
    font-size: 16px;
    color: #333;
}

.pay_form_content {
    padding-top: 10px;
}

.pay_balance {
    font-size: 20px;
    color: #FF8000;
}

.pay_form_sign {
    margin-left: 6px;
    font-size: 14px;
    color: #333;
}

.pay_form_tips {
    font-size: 14px;
    color: #999;
}

.pay_modepayment_content {
    padding: 5px 30px 0 30px;
}

.pay_modepayment_content > ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.pay_modepayment_content > ul > li,
.pay_paymentaccount_content > ul > li {
    display: flex;
    margin: 0 20px 10px 0;
    background-color: #F9F9FD;
    border: 1px solid #E7EBF6;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    position: relative;
}

.pay_modepayment_content > ul > li {
    min-width: 132px;
    height: 40px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    /*! autoprefixer: off */
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    /* autoprefixer: on */ 
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.pay_modepayment_content > ul > li > i.tb {
    margin-right: 6px;
    font-size: 16px;
}

.pay_modepayment_content > ul > li > span {
    font-size: 14px;
    color: #666;
}

.pay_modepayment_content > ul > li > i.icon-xuanzezhuangtai,
.pay_paymentaccount_content > ul > li > i.icon-xuanzezhuangtai {
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 24px;
    color: #FF8000;
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
}

.pay_modepayment_content > ul > li.active,
.pay_paymentaccount_content > ul > li.active {
    border-color: #FF8000;
    background-color: #FDF5EC;
}

.pay_modepayment_content > ul > li.active i.icon-xuanzezhuangtai,
.pay_paymentaccount_content > ul > li.active i.icon-xuanzezhuangtai {
    display: block;
}

.pay_paymentaccount_content {
    line-height: initial;
}

.pay_paymentaccount_content > ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.pay_paymentaccount_content > ul > li {
    min-width: 200px;
    height: 70px;
    padding: 6px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.pay_paymentaccount_list > small,
.pay_paymentaccount_list > span {
    font-size: 14px;
    color: #333;
}

.pay_paymentaccount_list > small {
    margin-right: 20px;
}

.pay_paymentaccount_list > small:last-child {
    margin-right: 0;
}

.pay_submit_content > button {
    min-width: 122px;
    height: 44px;
    font-size: 14px;
}

.qrcode_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
}

.qrcode_price {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
}

.qrcode_price > span {
    font-size: 14px;
    color: #333;
}

.qrcode_price > b {
    margin-bottom: -3px;
    font-size: 18px;
    color: #FF8000;
}

.qrcode_price > b::first-letter {
    font-size: 14px;
}

.qrcode_tiem {
    font-size: 14px;
    color: #999;
}

.qrcode_refresh {
    font-size: 14px;
    color: #3DBDA5;
    cursor: pointer;
}

.qrcode_main {
    width: 200px;
    height: 200px;
    position: relative;
}

.qrcode_main > img {
    width: 100%;
    height: 100%;
}

.qrcode_main span {
    width: 100%;
    height: 100%;
    line-height: 200px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background-color: rgba(0, 0, 0, .7);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}

.qrcode_tips {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.qrcode_tips > div {
    display: flex;
    flex-direction: column;
}

.qrcode_tips > div > span {
    line-height: 16px;
    font-size: 14px;
    color: #333;
}

.qrcode_tips > i {
    font-size: 26px;
    margin: 0 5px;
}

.qrcode_tips > i.icon-zhifubao {
    color: #06b4fd;
}

.qrcode_tips > i.icon-weixinzhifu {
    color: #6bcc03;
}

.qrcode_tips > i.icon-saoyisao {
    color: #ff8800;
}

.pay_online_btn {
    margin-left: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/shoppingcart/pay.vue